import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Checkbox } from "antd";
import { BeatLoader } from "react-spinners";
import http from "../../../../../../services/http";
import * as CompanyActions from "../../../../../../store/actions/company";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Close } from "@mui/icons-material";

const AddModal = ({
  data,
  show,
  currentCompany,
  isOrganization,
  onClose,
  isEdit,
  onSuccess = () => {},
}) => {
  const [isLoading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const history = useHistory();

  const editComanyHelper = (payload) => {
    http
      .put("user-company/" + currentCompany.id, payload)
      .then(({ data }) => {
        dispatch(CompanyActions.updateCompanyName(data));
        toast.success("Company updated successfully");
        onSuccess();
        onClose();
      })
      .catch(({ response }) =>
        toast.error(response?.data?.error || "Error updating company")
      )
      .finally(() => setLoading(false));
  };

  const createCompanyHelper = (payload) => {
    http
      .post("user-company", payload)
      .then(({ data }) => {
        dispatch(CompanyActions.addCompany(data));
        dispatch(CompanyActions.setSelectedCompany(data));
        toast.success("Company created successfully");
        onSuccess(data);
        onClose();
        history.push("/company-submission");
      })
      .catch(({ response }) =>
        toast.error(response?.data?.error || "Error creating company")
      )
      .finally(() => setLoading(false));
  };

  const submitHandler = (values) => {
    const payload = {
      company_name: values.company_name,
      shared: values.shared ?? false,
      organization: values.shared ? isOrganization : null,
    };
    const request = isEdit ? editComanyHelper : createCompanyHelper;
    setLoading(true);
    request(payload);
  };

  useEffect(() => {
    form.resetFields();
    if (data && isEdit) form.setFieldsValue(data);
  }, [show, isEdit, data]);

  return (
    <Modal
      visible={show}
      centered
      width={600}
      className="add-company-modal"
      footer={null}
      onCancel={onClose}
      closable={false}
    >
      <button className="close-btn" onClick={onClose}>
        <Close />
      </button>
      <h2>{isEdit ? "Edit" : "Add"} Company</h2>
      <p>
        {isEdit
          ? "Please type the new name of the company."
          : "Please type the name of the company that you would like to add."}
      </p>
      <Form form={form} onFinish={submitHandler} className="customize-form">
        <label htmlFor="name">Name</label>
        <Form.Item
          name="company_name"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "Company name is required",
            },
            {
              max: 100,
              message: "Company name must not exceed 100 characters",
            },
          ]}
        >
          <Input type="text" placeholder="Enter company name" />
        </Form.Item>
        {isOrganization && (
          <div className="share-company-box">
            <Form.Item name="shared" valuePropName="checked">
              <Checkbox id="share-company" disabled={isEdit && !data.created_by_user}>
                Share with organization?
              </Checkbox>
            </Form.Item>
          </div>
        )}
        <div className="action-box">
          <button type="button" onClick={onClose}>
            Cancel
          </button>
          <button className="submit" type="submit">
            {isLoading ? (
              <BeatLoader size={8} color="#000" />
            ) : isEdit ? (
              "Update"
            ) : (
              "Create"
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddModal;
